import type React from "react";

interface ProfileListProps {
  readonly children: React.ReactNode;
}

export function ProfileList({ children }: ProfileListProps): React.JSX.Element {
  return <div className="flex flex-col">{children}</div>;
}
